export class WebPushNotificationsStorage {
    static readonly key: string = 'simpleStorage';
    static readonly storageId: string = 'pushNotification';
    private readonly searches: any;
    private pushUserId: any;

    constructor() {
        this.searches = this.getSearches()
        this.pushUserId = this.getPushUserId();
    }

    private getSearches() {
        let storage = this.getStorageKey();
        if (!storage) {
            this.setLocalStorageId();
            storage = this.getStorageKey();
        }
        if (!storage[WebPushNotificationsStorage.storageId]) {
            this.setLocalStorageId();
        }
        storage = this.getStorageKey();

        return storage[WebPushNotificationsStorage.storageId].searches;
    }

    private getStorageKey() {
            return JSON.parse(<string>window.localStorage.getItem(WebPushNotificationsStorage.key));
    }

    private setLocalStorageId() {
        window.localStorage.setItem(WebPushNotificationsStorage.key,
            JSON.stringify({[WebPushNotificationsStorage.storageId]:{"id":[WebPushNotificationsStorage.storageId],"searches":{}}}));
    }

    public getSearch(search: string) {
        return this.searches[search];
    }

    public saveSearch(search: string) {
        this.searches[search] = true;
        this.saveStorage()
    }

    public getPushUserId(): string {
        let storage = this.getStorageKey();
        if (!storage) {
            this.setLocalStorageId();
            storage = this.getStorageKey();
        }
        if (!storage[WebPushNotificationsStorage.storageId]) {
            this.setLocalStorageId();
        }
        storage = this.getStorageKey();

        return storage[WebPushNotificationsStorage.storageId].pushUserId || '';
    }

    public savePushUserId(pushUserId: string) {
        this.pushUserId = pushUserId;
        this.saveStorage()
    }

    private saveStorage() {
        let storage = this.getStorageKey();
        storage[WebPushNotificationsStorage.storageId].searches = this.searches;
        storage[WebPushNotificationsStorage.storageId].pushUserId = this.pushUserId;
        window.localStorage.setItem(WebPushNotificationsStorage.key, JSON.stringify(storage));
    }
}